import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_ADJUSTMENT: 'adjustment_add',
  EDIT_ADJUSTMENT: 'adjustment_change',
  DELETE_ADJUSTMENT: 'adjustment_delete',
  VIEW_ADJUSTMENT: 'adjustment_view'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_ADJUSTMENT,
    PERMISSIONS.EDIT_ADJUSTMENT,
    PERMISSIONS.DELETE_ADJUSTMENT,
    PERMISSIONS.VIEW_ADJUSTMENT
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_ADJUSTMENT
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_ADJUSTMENT,
    PERMISSIONS.VIEW_ADJUSTMENT
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_ADJUSTMENT,
    PERMISSIONS.VIEW_ADJUSTMENT
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_ADJUSTMENT
  ]
};

const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createAdjustment: () => hasPermission(PERMISSIONS.CREATE_ADJUSTMENT),
    editAdjustment: () => hasPermission(PERMISSIONS.EDIT_ADJUSTMENT),
    deleteAdjustment: () => hasPermission(PERMISSIONS.DELETE_ADJUSTMENT),
    viewAdjustment: () => hasPermission(PERMISSIONS.VIEW_ADJUSTMENT)
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;
